export default __webpack_public_path__ + "static/media/img_chart_grade_B-.556fc2d7d381571baeaca288388262d0.svg";